/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchForSource
 */
export interface SearchForSource {
    /**
     * 
     * @type {string}
     * @memberof SearchForSource
     */
    name: string;
}

/**
 * Check if a given object implements the SearchForSource interface.
 */
export function instanceOfSearchForSource(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function SearchForSourceFromJSON(json: any): SearchForSource {
    return SearchForSourceFromJSONTyped(json, false);
}

export function SearchForSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchForSource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function SearchForSourceToJSON(value?: SearchForSource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

